import { render, staticRenderFns } from "./updateCardWindow.vue?vue&type=template&id=1e5878a6&scoped=true"
import script from "./updateCardWindow.vue?vue&type=script&lang=js"
export * from "./updateCardWindow.vue?vue&type=script&lang=js"
import style0 from "./updateCardWindow.vue?vue&type=style&index=0&id=1e5878a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5878a6",
  null
  
)

export default component.exports